import React from "react";
import ReactDOM from "react-dom/client";

import { LocaleProvider } from "@app/scripts/react-providers/locales";
import { AddressList } from "@app/scripts/react-address/components/AddressList";

class AddressElem extends HTMLElement {
  connectedCallback() {
    const script = this.querySelector("[data-addresses");
    let addresses = [];

    try {
      addresses = JSON.parse(script?.innerHTML ?? "[]");
    } catch (error) {
      console.error(error);
    }

    const root = ReactDOM.createRoot(this);

    root.render(
      <LocaleProvider>
        <AddressList addresses={addresses} />
      </LocaleProvider>
    );
  }
}

customElements.define("address-list", AddressElem);
